import { useTranslation } from 'react-i18next';

import type { IncidentListItem } from './incidentsApi';

export type IncidentArchiveSummaryBoxProps = {
  incidents: IncidentListItem[] | null;
};

export function IncidentArchiveSummaryBox({ incidents }: IncidentArchiveSummaryBoxProps) {
  const { t } = useTranslation();

  const sums = [
    { key: 'total', label: t('IncidentArchive_Sum_Total'), count: incidents?.length },
    {
      key: 'withVideo',
      label: t('IncidentArchive_Sum_WithVideo'),
      count: incidents?.filter((incident) => incident.liveVideoState !== 'Inactive').length,
    },
  ];

  return (
    <div className="container">
      <div className={`row align-items-end bg-light rounded-3 p-1 mb-2${incidents == null ? ' placeholder-glow' : ''}`}>
        {sums.map(({ key, label, count }) => (
          <div className="col-6 text-center" key={key}>
            <div className="x-small">{label}</div>
            <div className="fs-4">{count ?? <span className="placeholder col-5"></span>}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
